import { axiosInstance as axios } from 'Api'
import { handlingResponse, generateUniqSerial } from 'Utility/globalMethods'
/* eslint-disable global-require */
if (process.env.ISMOCK) {
  require('Mocks/operations/operations')
}

export async function callGetOperationTerminalId(params) {
  const operationId = params.operationId

  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}gateway/internal/operations/${operationId}/terminal`,
      headers: {
        merchantId: params.merchantId,
        tenantId: params.tenantId,
        roles: params.roles
      },
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callGetOperationDetail(params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}api/v1/operations/${params.operationId}`,
      headers: {
        'Terminal-Id': `${params.terminalId}`,
        merchantId: params.merchantId,
        tenantId: params.tenantId,
        roles: params.roles
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callGetOperations(params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}api/v1/operations`, //?${params?.rsqlString || {}}`,
      params: params.queryParams,
      headers: {
        tenantId: params.headers.tenantId,
        merchantId: params.headers.merchantId,
        roles: params.headers.roles,
        ...(params.headers.terminalId && { 'Terminal-Id': params.headers.terminalId })
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function callGetParameters({ headers }) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}gateway/internal/filter/parameters`,
      headers
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callGetOperationActions(params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}api/v1/operations/${params.id}/actions`,
      headers: {
        'Terminal-Id': `${params.terminalId}`,
        merchantId: params.merchantId,
        tenantId: params.tenantId,
        roles: params.roles
      },
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getPaymentMethodsList(params) {
  try {
    const data = await axios({
      method: 'post',
      url: `${process.env.MERCHANT_PROFILE_API}api/v1/merchants/${params.tenantId}/${params.merchantId}/terminals/${params.terminalId}/payment_methods`,
      headers: {
        'Terminal-Id': params.terminalId,
        merchantId: params.merchantId,
        tenantId: params.tenantId,
        roles: params.roles
      },
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callRetrieveOperationsExportFile({ format, queryParams, headers }) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}gateway/internal/operations/exports/${format}`,
      headers,
      params: queryParams,
      responseType: 'blob'
    })

    if (data.status === 400) {
      const promise = await data.data.text()
      return handlingResponse({ ...data, data: JSON.parse(promise) })
    }

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

// ACTIONS CALL
export async function callCaptureOperation(params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: `${process.env.PHOENIX_API}/api/v1/operations/${params.operationId}/captures`,
      headers: {
        'Idempotency-Key': generateUniqSerial(),
        'Terminal-Id': `${params.terminalId}`,
        merchantId: params.merchantId,
        tenantId: params.tenantId,
        roles: params.roles
      },
      data: { ...params.payload }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function callRefundOperation(params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: `${process.env.PHOENIX_API}/api/v1/operations/${params.operationId}/refunds`,
      headers: {
        'Idempotency-Key': generateUniqSerial(),
        'Terminal-Id': `${params.terminalId}`,
        merchantId: params.merchantId,
        tenantId: params.tenantId,
        roles: params.roles
      },
      data: { ...params.payload }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function callCancelOperation(params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: `${process.env.PHOENIX_API}/api/v1/operations/${params.operationId}/cancels`,
      headers: {
        'Terminal-Id': `${params.terminalId}`,
        merchantId: params.merchantId,
        tenantId: params.tenantId,
        roles: params.roles
      },
      data: { ...params.payload }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function callIncrementalOperation(params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: `${process.env.PHOENIX_API}api/v1/incrementals`,
      headers: {
        'Idempotency-Key': generateUniqSerial(),
        'Terminal-Id': `${params.terminalId}`,
        merchantId: params.merchantId,
        tenantId: params.tenantId,
        roles: params.roles,
        serviceScope: ""
      },
      data: { ...params.payload }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
